// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605071438/js/" + chunkId + "." + {"44":"e86be241","225":"2538a626","481":"040615df","486":"5b70ee76","770":"5de999e8"}[chunkId] + ".0.01739846425559577.chunk.js";
};